import type { QueryClient } from '@tanstack/react-query'

type PortalMetricQueryInvalidator = Pick<QueryClient, 'invalidateQueries'>

const PORTAL_METRIC_QUERY_KEYS = [
  // portal_metrics: dashboard.overview
  ['dashboard', 'overview'],
  // portal_metrics: dashboard.interventions_7_days
  ['dashboard', 'interventions-7days'],
  // portal_metrics: dashboard.jobs_by_category
  ['dashboard', 'jobs-by-category'],
  // portal_metrics: dashboard.technician_ranking
  ['dashboard', 'technician-ranking'],
  // portal_metrics: quotes.summary
  ['quotes', 'summary'],
  // portal_metrics: invoices.summary
  ['invoices', 'summary'],
  // portal_metrics: payments.summary
  ['payments', 'summary'],
  // portal_metrics: clients.summary
  ['clients', 'summary'],
  // portal_metrics: contracts.summary
  ['contracts', 'summary'],
  // portal_metrics: technicians.monthly_revenue
  ['technicians', 'list'],
] as const

function invalidateMetricQueries(qc: PortalMetricQueryInvalidator) {
  PORTAL_METRIC_QUERY_KEYS.forEach(queryKey => {
    void qc.invalidateQueries({ queryKey })
  })
}

export function invalidatePortalMetricQueries(
  qc: PortalMetricQueryInvalidator
) {
  invalidateMetricQueries(qc)

  if (typeof window === 'undefined') return
  ;[2_000, 6_000].forEach(delay => {
    window.setTimeout(() => invalidateMetricQueries(qc), delay)
  })
}
